<template>
  <div class="instruction-panel-entry">
    <h2 class="h2">{{ $t("instruction-panel.labellisation-evaluation-finale.title") }}</h2>

    <EvaluationPanel
      :projet-annuel="project"
      :evaluation="project.evaluationFinale"
      :read-only="true"
      :instruction-panel-width="instructionPanelWidth"
      :is-evaluation-finale="true"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue"
import { ProjetAnnuelDTO } from "@/model/bean/GeneratedDTOs"
import EvaluationPanel from "@/pages/instruction/side-panel/commons/labellisation/EvaluationPanel.vue"

export default defineComponent({
  name: "InstructionPanelLabellisationEvaluationFinale",
  components: {
    EvaluationPanel,
  },
  props: {
    project: {
      type: Object as PropType<ProjetAnnuelDTO>,
      required: true,
    },
    instructionPanelWidth: {
      type: Number,
      required: true,
    },
  },
})
</script>
